/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationState        from 'g3w-state';
import GUI                     from 'g3w-app';

import { getUniqueDomId }      from 'utils/getUniqueDomId';
import { sameOrigin }          from 'utils/sameOrigin';
import { waitFor }             from 'utils/waitFor';
import { XHR }                 from 'utils/XHR';
import { getCatalogLayerById } from 'utils/getCatalogLayerById';

import userMessage             from 'components/UserMessage.vue';
import ContextMenu             from 'components/ContextMenu.vue';
import ModalLogin              from 'components/ModalLogin.vue';
import ModalAddlayer           from 'components/ModalAddLayer.vue';
import ModalChangemap          from 'components/ModalChangeMap.vue';
import ModalMetadata           from 'components/ModalMetadata.vue';
import CatalogTree             from 'components/CatalogTree.vue';
import { gettext as _ }        from 'g3w-i18n';


const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'app',

  data() {
    return {
      state:                 ApplicationState,
      GUI,
      ApplicationState,
      language:              null,
      custom_links:          (window.initConfig.header_custom_links || []).concat(ApplicationState.navbaritems).filter(Boolean).map(l => Object.assign(l, { id: l.id || getUniqueDomId() })),
      mouse: {
        visible:     true,
        switch_icon: false,
        epsg_4326:   false,
        tooltip:     null,
      },
      externalayers:    {
        checked:   false,
        collapsed: false,
      },
      // user themes
      active_theme:             ApplicationState.map_theme,
      theme_selector_collapsed: 'collapsed' === ApplicationState.project.state.toc_themes_init_status,
      custom_theme_input:       null,
      theme_dialog_open:        false,
    }
  },

  components: {
    userMessage,
    ContextMenu,
    ModalLogin,
    ModalAddlayer,
    ModalChangemap,
    ModalMetadata,
    CatalogTree,
  },

  computed: {

    languages() {
      const languages = (Array.isArray(this.initConfig.i18n) && this.initConfig.i18n || []).sort((a, b) => a[0].localeCompare(b[0]));
      return languages.length > 1 && languages;
    },

    initConfig() {
      return window.initConfig;
    },

    urls() {
      return this.initConfig.urls;
    },

    logo_url() {
      return ApplicationState.project.state.thumbnail || `${this.initConfig.mediaurl}${window.initConfig.header_logo_img}`;
    },

    project_title() {
      return ApplicationState.project.getState().name;
    },

    user() {
      return this.initConfig?.user?.username ? this.initConfig.user : null;
    },

    login_url() {
      return this.initConfig.user.login_url;
    },

    /**
     * @since 3.11.0
     */
    has_iframe_login() {
      return this.login_url && ('/' === this.login_url[0] || sameOrigin(this.login_url, window.location.href));
    },

    /**
     * @returns {boolean} whether it should list any related projects or maps.
     *
     * @since 4.1.0
     */
    has_related_maps() {
      return window.initConfig.macrogroups.length + window.initConfig.groups.length + window.initConfig.projects.length > 1;
    },

    main_title() {
      const main_title = this.initConfig.main_map_title;
      const group_name = this.initConfig.title || this.initConfig.slug;
      return main_title ? `${main_title} - ${group_name}` : group_name;
    },

    breadcrumb() {
      return this.state.content.contentsdata.filter(cd => cd?.options?.title).map(cd => [cd.options.title, cd.options.post_title].filter(Boolean).flat().join(' ')).flat();
    },

    has_panel() {
      return this.state.content.contentsdata.length > 0;
    },

    usermessage() {
      return this.state.usermessage;
    },

    showtitle() {
      if (this.state.content.contentsdata.length > 0) {
        const options = this.state.content.contentsdata.at(-1).options;
        if ( [true, false].includes(options.showtitle) ) { return options.showtitle }
      }
      return true;
    },

    styles() {
      return {
        map: {
          width:         `${this.state.map.sizes.width}px`,
          height:        `${this.state.map.sizes.height}px`,
        },
        content: {
          width:         `${this.state.content.sizes.width}px`,
          height:        `${this.state.content.sizes.height}px`,
        },
      }
    },

    contentTitle() {
      if (this.state.content.contentsdata.length) {
        return this.state.content.contentsdata.at(-1).options;
      }
    },

    previousTitle() {
      const title = (this.state.content.contentsdata.length > 1 && this.state.content.showgoback)
        //In case of no set title (ex. show form of feature - relation), show previous title
        ? this.state.content.contentsdata.at(-2).options.title || this.state.content.contentsdata.at(-3)?.options?.title?.[1]
        : null;
      return Array.isArray(title) ? title[1]: title;
    },

    title() {
      return ApplicationState.sidebar.title;
    },

    disabled() {
      return ApplicationState.sidebar.disabled;
    },

    panels() {
      return ApplicationState.sidebar.contentsdata;
    },

    showmainpanel() {
      return ApplicationState.sidebar.components.length > 0 && !this.panels.length;
    },

    componentname() {
      return ApplicationState.sidebar.components.length ? ApplicationState.sidebar.components.slice(-1)[0].getTitle(): '';
    },

    panelname() {
      return this.panels.length ? this.panels.slice(-1)[0].content.getTitle() : '';
    },

    version() {
      return 'Powered by G3W-SUITE ' + initConfig.version;
    },

    showmapunits() {
      return GUI.state.mapunits.length > 1;
    },

    /**
     * @since 4.1.0
     */
    is_staff() {
      return window.initConfig.user.is_staff;
    },

    custom_theme_invalid() {
      return this.custom_theme_input && this.ApplicationState.project.state.map_themes.project.concat(this.ApplicationState.project.state.map_themes.custom).find(({ theme }) => theme === this.custom_theme_input.trim());
    },

  },

  methods: {

    /**
     * @since 3.11.0
     */
    onCustomItemClick(e, item) {
      if (item.onclick) {
        e.preventDefault();
        return item.onclick();
      }
      if (!['modal', 'metadata'].includes(item.type)) {
        return;
      }
      e.preventDefault();
      if (item.target && 'modal' === item.type && document.querySelector(item.target)) {
        return $(item.target).modal('show');
      }
      if (item.target && 'metadata' === item.type && document.querySelector('#modal-metadata')) {
        $('#modal-metadata').modal('show');
        document.querySelector('#modal-metadata a[href="' + item.target + '"]').click();
        return;
      }
      document.body.insertAdjacentHTML('beforeend', /* html */`
        <div id = "custom_modal" class = "modal fade" tabindex="-1">
          <div class = "modal-dialog">
            <div class  = "modal-content">${ item.content }</div>
          </div>
        </div>
      `);
      $('#custom_modal').modal('show');
      $('#custom_modal').on('hidden.bs.modal', () => document.querySelector('#custom_modal')?.remove());
    },

    async showEmbedModal() {
      await GUI.getPermalink(new URL(window.location.href), {});
    },

    /**
     * @since 4.1.0
     */
    showLegendPanel() {
      GUI.showLegendPanel();
    },

    /**
     * @since 3.11.0
     */
    showaddLayerModal() {
      $('#modal-addlayer').modal('show');
    },

    /**
     * @since 3.8.0
     */
    openChangeMapMenu() {
      $('#modal-changemap').modal('show');
    },

    isNotLastCrumb(index) {
      return index < this.breadcrumb.length - 1;
    },

    closeContent() {
      GUI.closeContent();
    },

    async popContent(size = 1) {
      // remove multiple elements from stack
      if (typeof size === 'number' && !isNaN(size) && size > 0) {
        while (size > 0) {
          await GUI.popContent();
          size--;
        }
      }
    },

    closeUserMessage() {
      GUI.closeUserMessage();
    },

    async onResize(e) {
      const sidebar = document.getElementById('g3w-view-content');
      const panel   = ApplicationState.layout[ApplicationState.layout.__current].rightpanel;
      let rect, dx, dy;

      this.state.content.disabled = true;

      const mousemove = e => {
        e.preventDefault();
        rect = sidebar.getBoundingClientRect();

        dx   = e.pageX - rect.left - window.scrollX;
        dy   = e.pageY - rect.top - window.scrollY;

        const wrapper = document.querySelector('.content-wrapper');

        panel.width  = Math.min(Math.max(
          Math.round((200               / wrapper.clientWidth)  * 100),
          Math.round(((rect.width  -dx) / wrapper.clientWidth)  * 100),
        ), 90);

        panel.height = Math.min(Math.max(
          Math.round((200               / wrapper.clientHeight) * 100),
          Math.round(((rect.height -dy) / wrapper.clientHeight) * 100),
        ), 90);

        const viewW = document.querySelector('#app').getBoundingClientRect().width - document.querySelector('.main-sidebar').getBoundingClientRect().width - document.querySelector('.main-sidebar').getBoundingClientRect().left - window.scrollX;
        const viewH = window.innerHeight - document.querySelector('.navbar').offsetHeight;

        const h_split = 'h' === this.state.split;
        const v_split = 'v' === this.state.split;
        
        // percentage of secondary view (content)
        const scale = (h_split ? panel.width : panel.height) /100;

        // size "content"
        Object.assign(this.state.content.sizes, {
          width:  (h_split ?  (viewW * scale) : viewW),
          height: (v_split ? (viewH * scale) : viewH),
        });
      };

      const mouseup = async e => {
        document.removeEventListener('mousemove', mousemove);
        if (!this.disabled && 'h' === this.state.split && panel.width > 65) {
          GUI.hideSidebar();
        }
        this.state.content.disabled = false;
        GUI._layout();
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup, { once: true });
    },

    resizeFull() {
      const panel = ApplicationState.layout[ApplicationState.layout.__current].rightpanel;
      if ('h' === ApplicationState.split) {
        panel.width_100 = !panel.width_100;
      } else {
        panel.height_100 = !panel.height_100;
      }
      GUI._layout();
    },

    /**
     * @sine 4.0.0
     */
    splitContent(e) {
      const split            = GUI.getCurrentContent().options.split;
      ApplicationState.split = GUI.getCurrentContent().options.split = 'v' === split ? 'h' : 'v';
      e.target.setAttribute('data-original-title', `Dock ${'h' === split ? 'right' : 'bottom'}`);
      GUI._layout();
    },

    closePanel() {
      GUI.closePanel();
    },

    async closeAllPanels() {
      ApplicationState.sidebar.title = null;
      const data = ApplicationState.sidebar.contentsdata;
      if (data.length) {
        await Promise.allSettled(data.map(async d => await d.content.unmount()));
        data.splice(0, data.length);
      }
    },

    /**
     * @since 3.11.0
     */
    toggleSidebar() {
      GUI.toggleSidebar();
    },

    /**
     * @since 4.1.0
     */
    showSidebar() {
      GUI.showSidebar();
    },

    /**
     * Toggle sidebar tree items on click
     * 
     * @since 3.11.0
     */
    toggleSidebarItem(e) {
      // skip toggling element
      if ('g3w-menu' === e.target.id) {
        return;
      }

      const mini      = document.body.classList.contains('sidebar-mini');
      const collapsed = document.body.classList.contains('sidebar-collapse');

      const li        = e.target.closest('.sidebar-item');
      const component = ApplicationState.sidebar.components.find(comp => li.id === comp.id);

      // open sidebar only in case of mini/collapsed sidebar and has a component that has a li id collapsible
      if (mini && collapsed && component?.collapsible) {
        GUI.showSidebar();
      }

      const open      = component?.getOpen();
      const menu      = li.querySelector('.treeview-menu');

      // skip toggling element
      if (!component || (open && collapsed) || (menu && menu.contains(e.target))) {
        return;
      }

      // automatically toggle sidebar on mobile
      if (!component.collapsible && window.innerWidth <= 767) {
        GUI.toggleSidebar();
      }

      component.click({ open: !open });
    },

    /**
     * ORIGINAL SOURCE: src/components/Map.vue@4.0.0
     * 
     * @since 4.1.0
     */
    onDrop(e) {
      document.querySelector('.drop-area').toggleAttribute('hidden', 'dragenter' !== e.type);
      if (e.dataTransfer.files && 'drop' === e.type) {
        const q = document.querySelector.bind(document);
        // set modal options
        const setOption = async (el, value) => {
          el = '#modal-addlayer ' + el;
          await waitFor(() => q(el), 1000);
          q(el).value = value;
          q(el).dispatchEvent(new Event('input'));
          q(el).dispatchEvent(new Event('change'));
        }
        const setFile = async (file) => {
          await waitFor(() => !q('#add-layer-type').value, 5000);
          if (GUI.getLayerByName(file.name)) {
            return console.assert(!GUI.getLayerByName(file.name), `Unable to add layer: ${file.name}`);
          }
          setTimeout(() => console.assert(GUI.getLayerByName(file.name), `Unable to add layer: ${file.name}`), 2500);
          await setOption('#add-layer-type', 'file');
          await waitFor(() => q('#addcustomlayer input[type="file"]'), 1000);
          const data = new DataTransfer();
          data.items.add(file);
          q('#addcustomlayer input[type="file"]').files = data.files;
          q('#addcustomlayer input[type="file"]').dispatchEvent(new Event('change'));
          $('#modal-addlayer').modal('show');
        }
        setFile(e.dataTransfer.files[0]);
      }
    },

    /**
     * ORIGINAL SOURCE: src/components/Map.vue@4.0.0
     * 
     * @since 4.1.0
     */
    switchMapsCoordinateTo4326() {
      this.mouse.epsg_4326 = !this.mouse.epsg_4326;
      GUI.getMapControl('mouseposition').dispatchEvent({
        type: 'change:epsg',
        epsg: this.mouse.epsg_4326 ? 'EPSG:4326' : GUI.getEpsg(),
      })
    },

    /**
     * @since 4.1.0
     */
    acceptCookie() {
      window.localStorage.setItem('cookie:accepted', true);
      this.state.cookie_accepted = true;
    },

    /**
     * @since 4.1.0
     */
    expandCollapseExternaLayers() {
      this.externalayers.collapsed = !this.externalayers.collapsed;
    },

    /**
     * @since 4.1.0
     */
    toggleExternalLayers() {
      this.externalayers.checked = !this.externalayers.checked;
      [
        ...(this.ApplicationState.catalog.external?.vector || []),
        ...(this.ApplicationState.catalog.external?.wms || []),
        ...(this.ApplicationState.catalog.external?.tms || []),
      ].forEach(l => l.checked = this.externalayers.checked);
    },

    /**
     * @since 4.1.0 Remove external layers
     */
    removeExternalLayers() {
      [
        ...(this.ApplicationState.catalog.external?.vector || []),
        ...(this.ApplicationState.catalog.external?.wms || []),
        ...(this.ApplicationState.catalog.external?.tms || []),
      ].forEach(l =>  GUI.removeExternalLayer(l.name));
    },

    /**
     * @since 4.1.0
     */
    updateExternalLayersChecked() {
      const checked = [
        ...(ApplicationState.catalog.external?.vector || []),
        ...(ApplicationState.catalog.external?.wms || []),
        ...(ApplicationState.catalog.external?.tms || []),
      ];
      this.externalayers.checked = !!(checked.length && checked.every(l => l.checked));
    },

    /**
     * get map Theme_configuration
     * 
     * @since 4.1.0
     */
    async getThemeConfig(theme_name) {
      // get map theme configuration from map_themes project config
      const config  = Object.values(ApplicationState.project.state.map_themes).flat().find(c => theme_name === c.theme);
      try {
        if (config && undefined === config.layerstree) {
          const { result, data } = await XHR.get({ url: `${ApplicationState.project.urls.map_themes}${theme_name}/` });
          if (result) {
            config.layerstree = data;
          }
        }
      } catch(e) {
        console.warn('Error while retreiving map theme configuration', e);
      }
      return config;
    },

    /**
     * Change view
     *
     * @fires GUI~layer-change-style
     * 
     * @since 4.1.0
     */
    async changeTheme(map_theme) {
      //in the case of save new custom map theme, no need to emit event
      //in case of remove custom map theme at moment se as default
      if (null === map_theme) {
        return;
      }

      GUI.closeContent();

      // change map theme
      this.ApplicationState.map_theme.change = true;     
      this.ApplicationState.catalog.layerstrees[0].checked = true;

      const project  = ApplicationState.project;

      /** map theme config */
      const theme    = await this.getThemeConfig(map_theme);

      // create a chages need to apply map_theme changes to map and TOC
      const changes  = {}; // key is the layer id and object has style, visibility change (Boolean)
      const promises = [];
      const groups   = [];

      /**
       * Traverse current layerstree of TOC and get changes with the new one related to map_theme choose
       * 
       * @param themeTree new tree
       * @param layerstree   current tree
       */
      const traverse = (themeTree, layerstree, checked) => {
        themeTree
          .forEach((node, index) => {
            if (node.nodes) { 
              // case of a group
              groups.push({
                node,
                group: layerstree[index]
              });
              traverse(node.nodes, layerstree[index].nodes, checked && node.checked);
            } else {
              // case of layer
              node.style = theme.styles[node.id]; // set style from map_theme
              if (layerstree[index].checked !== node.visible) {
                changes[node.id] = {
                  visibility: true,
                  style:      false
                };
              }
              layerstree[index].checked = node.visible;
              // if it has a style settled
              if (node.style) {
                const promise = new Promise(resolve => {
                  const changeStyle = async node => {
                    if (undefined === changes[node.id]) {
                      changes[node.id] = {
                        visibility: false,
                        style:      false
                      }
                    }
                    changes[node.id].style = await project.getLayerById(node.id).changeCurrentStyle(node.style);
                    resolve();
                  };
                  if (project.getLayersStore()) { changeStyle(node) }
                  else { (node => setTimeout(() => changeStyle(node)))(node) }// case of starting project creation
                });
                promises.push(promise);
              }
            }
        });
      };
      traverse(
        theme.layerstree,
        this.ApplicationState.catalog.layerstrees[0].tree[0].nodes ?? this.ApplicationState.project.state.layerstree
      );

      await Promise.allSettled(promises);

      // all groups checked after layer checked so is set checked but not visible
      groups.forEach(({ group, node: { checked, expanded }}) => {
        group.checked  = checked;
        group.expanded = expanded;
      });

      // get all layers with styles
      const layers  = Object.keys(changes).filter(id => changes[id].style);
      const styles  = (await this.getThemeConfig(map_theme)).styles;

      // clear categories
      layers.forEach(id => {
        if (!changes[id].visible) {
          const layer = getCatalogLayerById(id);
          layer.clearCategories();
          layer.change();
        }
      });

      // apply styles on each layer
      layers.forEach(id => GUI.emit('layer-change-style', { layerId: id, style: styles[id] }));

      this.ApplicationState.map_theme.change = false;
    },

    /**
     * @since 4.1.0
     */
    toggleThemeSelector() {
      //skip when no show form
      if (this.theme_dialog_open) { 
        return; 
      }
      //in case of no new form map_theme is show
      document.getElementById('g3w-themes').classList.toggle('menu-open');
      this.theme_selector_collapsed = !this.theme_selector_collapsed;
    },

    /**
     * Create params for save or update custom map theme
     * 
     * @since 4.1.0
     * 
     * @private
     */
    getThemeParams() {
      const params   = { layerstree: [], styles: {} };
      const traverse = (nodes, tree) => {
        nodes.forEach(node => {
          const item = undefined !== node.id
            ? {                                           // a layer node
              id:       node.id,
              name:     node.name,
              visible:  node.visible,
              expanded: node.expanded,
            }
            : {                                           // a group node
              name:                 node.name,
              checked:              node.checked,
              expanded:             node.expanded,
              'mutually-exclusive': node['mutually-exclusive']
            };
          // handle recursion (group node)
          if (Array.isArray(node.nodes)) {
            item.nodes = [];
            traverse(node.nodes, item.nodes);
          }
          // set style of layer
          if (undefined !== node.id) {
            params.styles[node.id] = node.styles.find(s => s.current).name; // get current layer style
          }
          tree.push(item);
        });
      };

      // loop through child nodes
      traverse(this.ApplicationState.catalog.layerstrees[0].tree[0].nodes, params.layerstree);

      return params;
    },

    /**
     * Save current theme (layerstree state)
     * 
     * @since 4.1.0
     */
    async saveTheme() {
      if (this.custom_theme_invalid) {
        return;
      }
      const theme = this.custom_theme_input;
      // skip when no name provided 
      if (!theme) {
        return;
      }
      try {
        const params   = this.getThemeParams();
        const response = await XHR.post({
          url:         `${ApplicationState.project.urls.map_themes}${encodeURIComponent(theme)}/`,
          contentType: 'application/json',
          data:        JSON.stringify(params),
        });
        // handle server error
        if (!response.result) {
          throw response;
        }
        this.ApplicationState.project.state.map_themes.custom.push({ theme: this.custom_theme_input, styles: params.styles });
        // show a success add custom matp theme message to user
        GUI.showUserMessage({ type: 'success', message: 'Theme saved successfully', autoclose: true });
        // close dialog
        this.theme_dialog_open    = false;
        //set as current active name map theme
        this.active_theme.theme = this.custom_theme_input;
        //need to wait watch
        await this.$nextTick();
        //set custom map theme value to null. Reset value
        this.custom_theme_input = null;
      } catch(e) {
        console.warn(e);
        GUI.showUserMessage({ type: 'alert', message: e.error || 'server_error' });
      }
    },

    /**
     * @since 4.1.0
     */
    async updateTheme(theme) {
      // skip when no name provided
      if (!theme) {
        return;
      }
      try {
        const params   = this.getThemeParams();
        const response = await XHR.post({
          url:         `${ApplicationState.project.urls.map_themes}${encodeURIComponent(theme)}/`,
          contentType: 'application/json',
          data:        JSON.stringify(params),
        });
        // handle server error
        if (!response.result) {
          throw response;
        }
        // update custom map theme styles
        Object.assign(this.ApplicationState.project.state.map_themes.custom.find(mt => theme === mt.theme), {
          styles:     params.styles,
          layerstree: params.layerstree,
        });
        // show a success update map theme message to user
        GUI.showUserMessage({ type: 'success', message: 'Theme updated successfully', autoclose: true });
      } catch(e) {
        console.warn(e);
        GUI.showUserMessage({ type: 'alert', message: e.error || 'server_error' });
      }
    },

    /**
     * Remove map theme from custom themes
     * 
     * @since 4.1.0
     */
    async deleteTheme(theme) {
      const ok = await GUI.confirm(_('Do you want delete the theme?'));

      // skip when no confirm and no theme is passed
      if (!ok || !theme) {
        return;
      }

      try {
        const response = await (await fetch(`${ApplicationState.project.urls.map_themes}${encodeURIComponent(theme)}/`, {
          method: 'DELETE',
        })).json();
        // handle server error
        if (!response.result) {
          throw response;
        }
        this.ApplicationState.project.state.map_themes.custom = this.ApplicationState.project.state.map_themes.custom.filter(({ theme: t }) => t !== theme);
        // show a success message to user
        GUI.showUserMessage({ type: 'success', message: 'Theme deleted successfully', autoclose: true })
        // in the case of deleted current map theme set current theme to null
        if (theme === this.active_theme.theme) {
          this.active_theme.theme = null;
        }
      } catch(e) {
        console.warn(e);
        GUI.showUserMessage({ type: 'alert', message: e.error || 'server_error' });
      }
    },

    /**
     * @since 4.1.0
     */
    onBeforetoggleThemeDialog(e) {
      if ('closed' === e.newState) {
        this.theme_dialog_open = false;
      }
    },

  },

  watch: {

    language: {
      immediate: true,
      async handler(lang, plang) {
        //In case of no language, loading time, set default language en
        if (!lang) {
          // lazy load i18n translations
          _.register('en', (await import(`${initConfig.urls.clienturl}locales/en.js`)).default);
          return;
        }

        history.replaceState(null, null, window.location.pathname.split('/').map((part, index) => index === 1 ? lang : part).join('/') + window.location.search + window.location.hash);

        // lazy load i18n translations
        try {
          _.register(lang, (await import(`${initConfig.urls.clienturl}locales/${lang}.js`)).default);
        } catch(e) {
          GUI.showUserMessage({ type: 'warning', message: e.toString(), autoclose: true });
        }

        //wait loading all plugins. Need to wait for plugins to be loaded when open apllication first time
        await waitFor(() => 0 === ApplicationState.plugins.length);

        ApplicationState.language = lang;

        //need to wait change laguage. Some plugins watch language change
        await this.$nextTick();

        //ge locale from current languare or previuous language to check if plugins are translated
        const locale             = Object.keys(ApplicationState.locales[plang || lang]);
        const installed_plugins  = Object.keys(initConfig.plugins); //plugins provided by the server
        const i18n_plugins       = installed_plugins.filter(name => locale.find(k => k.includes(`plugins.${name}`)));
        // wait until all plugins have been translated
        await waitFor(() => {
          return i18n_plugins.length === i18n_plugins.filter(name => locale.find(key => key.startsWith(`plugins.${name}`))).length;
        });

        /** @since 4.0.0 */
        GUI.emit('i18n-ready', lang);
      },
    },

    /**
     * @since 4.1.0
     */
    'ApplicationState.catalog.external.vector': {
      immediate: true,
      handler() {
        this.updateExternalLayersChecked();
      },
    },

    /**
     * @since 4.1.0
     */
    'ApplicationState.catalog.external.wms': {
      immediate: true,
      handler() {
        this.updateExternalLayersChecked();
      },
    },

    /**
     * @since 4.1.0
     */
    'active_theme.theme': {
      immediate: false,
      handler(map_theme) {
        this.changeTheme(map_theme);
      }
    },

    /**
     * @since 4.1.0
     */
    async theme_dialog_open(bool) {
      this.custom_theme_input = null;
      if (bool) {
        this.$refs.add_map_theme.showModal();
      } else {
        this.$refs.add_map_theme.close();
      }
    },

  },

  created() {
    this.language = this.initConfig.user.i18n;
  },

  async mounted() {

    document.body.appendChild(this.$el.querySelector('#modal-fullscreen'));

    //In case of sidebar collapssed by default
    if (document.body.classList.contains('sidebar-collapse')) {
      //need sync with GUI state
      GUI.hideSidebar();
    }

    this.language = this.initConfig.user.i18n;

    await this.$nextTick();

    document.getElementById('startingspinner')?.remove();

    document.body.classList.toggle('is-mobile', this.isMobile());
    document.body.classList.toggle('is-iframe', ApplicationState.iframe);

    if (!ApplicationState.iframe) {
      document.body.classList.add('sidebar-mini');
    }

    this.crs = GUI.getCrs();

    await this.$nextTick();

    GUI.once('after:setupControls', () => {
      if (GUI.getMapControl('mouseposition')) {
        this.mouse.switch_icon = (
          GUI.getMapControl('mouseposition')
          && 'EPSG:4326' !== GUI.getEpsg()
        );
        this.mouse.tooltip = `ESPG ${GUI.getCrs().split(':')[1]} ↔ WGS84`;
      } else {
        this.mouse.visible = false;
      }
    });

    await this.$nextTick();
    
    // in case of dynamic legend
    if (ApplicationState.project.state.context_base_legend) {
      GUI.on('change-map-legend-params', () => { GUI.getLegendSrc(); });
    }
    
    if ('legend' === ApplicationState.project.state.catalog_tab) {
      GUI.showLegendPanel();
    }
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.ApplicationState.disabled),expression:"ApplicationState.disabled"}],attrs:{"id":"app"}},[_c('nav',{ref:"navbar",staticClass:"navbar no-print",staticStyle:{"display":"flex","justify-content":"start","height":"50px"}},[(_vm.logo_url)?_c('a',{staticStyle:{"padding":"4px","display":"inline-block","height":"50px"},attrs:{"href":_vm.initConfig.header_logo_link || _vm.urls.frontendurl || '#',"target":_vm.initConfig.header_logo_link ? '_blank' : '',"aria-label":"logo"}},[_c('img',{staticStyle:{"height":"100%"},attrs:{"alt":"","src":_vm.logo_url}})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","hidden":""},on:{"click":_vm.toggleSidebar}},[_c('i',{staticClass:"fas fa-bars",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{staticStyle:{"margin-left":"8px"}},[_vm._v("MENU")])]),_vm._v(" "),_c('hgroup',{staticClass:"project_title"},[_c('p',{staticClass:"h2"},[_vm._v(_vm._s(_vm.main_title))]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.project_title))])]),_vm._v(" "),_c('ul',{staticClass:"nav-links",staticStyle:{"display":"flex","text-align":"center","white-space":"nowrap","list-style":"none","padding":"0","margin":"0"}},[_vm._l((_vm.custom_links),function(item){return _c('li',{key:item.id,class:("nav-" + (item.id)),style:({ order: item.position }),attrs:{"id":("g3w-nav-custom-links-" + (item.id))}},[_c('a',{attrs:{"href":item.url || '#',"target":item.target,"title":item.i18n ? item.title : ('&nbsp;' + item.title + '&nbsp;'),"data-placement":"bottom"},on:{"click":function($event){return _vm.onCustomItemClick($event, item)}}},[(item.icon)?_c('i',{class:item.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(item.img)?_c('img',{attrs:{"height":"20","src":item.img,"title":item.img_title,"alt":item.img_title || ''}}):_vm._e(),_vm._v(" "),(item.i18n)?_c('span',{directives:[{name:"t",rawName:"v-t",value:(item.text || item.title || item.img_title),expression:"item.text || item.title || item.img_title"}],attrs:{"hidden":item.text ? undefined : ''}}):_vm._e(),_vm._v(" "),(!item.i18n)?_c('span',{attrs:{"hidden":item.text ? undefined : ''},domProps:{"innerHTML":_vm._s(item.text || item.title || item.img_title)}}):_vm._e()])])}),_vm._v(" "),_c('li',{staticClass:"nav-user dropdown",attrs:{"id":"g3w-nav-account"}},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('i',{staticClass:"fas fa-user",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.user)?_c('span',[_vm._v(_vm._s(_vm.user.username))]):_c('span',[_vm._v(_vm._s(_vm.$t('sign_in')))]),_vm._v(" "),_c('i',{staticClass:"triangle"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[(_vm.user)?_c('li',{staticClass:"user-header"},[_vm._v("\n            👋\n            "),(!_vm.user.first_name && !_vm.user.last_name)?_c('span',[_vm._v(_vm._s(_vm.user.username))]):_c('span',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"user-footer"},[(!_vm.user)?_c('a',{staticClass:"nav-login btn btn-default btn-flat skin-color",attrs:{"href":"#","src":_vm.login_url,"data-toggle":_vm.has_iframe_login ? 'modal'        : undefined,"data-target":_vm.has_iframe_login ? '#modal-login' : undefined}},[_c('b',[_vm._v(_vm._s(_vm.$t('sign_in')))]),_c('i',{staticClass:"fas fa-sign-in-alt",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.admin_url)?_c('a',{staticClass:"nav-admin btn btn-default btn-flat skin-color",attrs:{"href":_vm.user.admin_url}},[_c('b',[_vm._v("Admin")]),_c('i',{staticClass:"fas fa-cog",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.urls.frontendurl)?_c('a',{staticClass:"nav-home btn btn-default btn-flat skin-color",attrs:{"href":_vm.urls.frontendurl}},[_c('b',[_vm._v(_vm._s(_vm.$t('homepage')))]),_c('i',{staticClass:"fas fa-home",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.logout_url)?_c('a',{staticClass:"nav-logout btn btn-default btn-flat skin-color",attrs:{"href":_vm.user.logout_url}},[_c('b',[_vm._v(_vm._s(_vm.$t('Logout')))]),_c('i',{staticClass:"fas fa-sign-out-alt",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"nav-embedmap btn btn-default btn-flat skin-color",attrs:{"href":"#"},on:{"click":_vm.showEmbedModal}},[_c('b',[_vm._v(_vm._s(_vm.$t('Embed map')))]),_c('i',{staticClass:"fa fa-share-alt",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.has_related_maps)?_c('a',{staticClass:"nav-changemap btn btn-default btn-flat",attrs:{"href":"#"},on:{"click":_vm.openChangeMapMenu}},[_c('b',[_vm._v(_vm._s(_vm.$t('changemap')))]),_c('i',{staticClass:"fas fa-sync-alt",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"nav-addlayer btn btn-default btn-flat",attrs:{"href":"#"},on:{"click":_vm.showaddLayerModal}},[_c('b',[_vm._v(_vm._s(_vm.$t('Add Layer')))]),_c('i',{staticClass:"fas fa-layer-group",attrs:{"aria-hidden":"true"}})])])])]),_vm._v(" "),(_vm.languages)?_c('li',{staticClass:"nav-lang",attrs:{"id":"g3w-nav-language"}},[_c('button',{staticStyle:{"display":"flex","gap":"5px","align-items":"center"},attrs:{"type":"button","commandfor":"nav-lang-dialog","command":"show-modal"}},[_c('img',{attrs:{"src":_vm.urls.staticurl +'img/flags/' + _vm.language.toLowerCase() + '.png',"width":"24","height":"16","alt":""}}),_vm._v("\n          "+_vm._s(_vm.languages.find(function (l) { return l[0] === _vm.language; }).at(1))+"\n          "),_c('i',{staticClass:"triangle",staticStyle:{"margin-top":"8px"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('dialog',{attrs:{"id":"nav-lang-dialog"},on:{"click":function($event){$event.target === $event.target.closest('dialog') && $event.target.closest('dialog').close()}}},[_c('form',{staticStyle:{"display":"grid","grid-template-columns":"repeat(auto-fill, minmax(120px, 1fr))","gap":"10px","user-select":"none"},attrs:{"method":"dialog"}},_vm._l((_vm.languages),function(lang){return _c('label',{key:lang[0],staticStyle:{"cursor":"pointer","text-align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],staticStyle:{"pointer-events":"none","margin-right":"8px"},attrs:{"type":"radio"},domProps:{"value":lang[0],"checked":_vm._q(_vm.language,lang[0])},on:{"click":function($event){$event.target.closest('dialog').close()},"change":function($event){_vm.language=lang[0]}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.urls.staticurl +'img/flags/' + lang[0].toLowerCase() + '.png',"width":"24","height":"16","alt":lang[0].toLowerCase()}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(lang[1]))])])}),0)])]):_vm._e()],2)]),_vm._v(" "),_c('aside',{class:{ 'main-sidebar no-print': true, 'g3w-disabled': _vm.disabled }},[_c('div',{staticClass:"sidebar-panel",attrs:{"hidden":_vm.panels.length <= 0}},[_c('div',{staticStyle:{"display":"flex","overflow":"hidden","line-height":"14px","font-size":"1.5em","min-height":"35px","border-bottom":"1px solid #FFF","padding-bottom":"5px","margin-bottom":"5px"},style:({ justifyContent: _vm.ApplicationState.sidebar.title ? 'space-between' : 'flex-end' })},[(_vm.title)?_c('h4',{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}],staticStyle:{"display":"inline-block","font-weight":"bold"}}):_vm._e(),_vm._v(" "),(_vm.panels.length > 1)?_c('button',{staticClass:"btn btn-outline",staticStyle:{"margin-left":"auto","margin-right":"1ch"},attrs:{"title":'back',"data-placement":"left"},on:{"click":_vm.closePanel}},[_c('i',{staticClass:"fas fa-chevron-left",style:({ opacity: _vm.ApplicationState.sidebar.btn_close ? '1' : '0.7', cursor: _vm.ApplicationState.sidebar.btn_close ? 'pointer' : 'not-allowed' }),attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:(_vm.ApplicationState.sidebar.tooltip_close || 'close'),expression:"ApplicationState.sidebar.tooltip_close || 'close'"}],staticClass:"btn btn-outline",attrs:{"type":"button","data-placement":"right"},on:{"click":function($event){_vm.ApplicationState.sidebar.btn_close && _vm.closeAllPanels()}}},[_c('i',{staticClass:"fas fa-times",style:({ opacity: _vm.ApplicationState.sidebar.btn_close ? '1' : '0.7', cursor: _vm.ApplicationState.sidebar.btn_close ? 'pointer' : 'not-allowed' }),attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"sidebar-panel-placeholder",attrs:{"id":"sidebar-panel-placeholder"}})]),_vm._v(" "),_c('ul',{staticClass:"sidebar-menu",attrs:{"id":"g3w-menu","hidden":!_vm.showmainpanel,"role":"menu","tabindex":"0"},on:{"click":_vm.toggleSidebarItem}},[_c('li',{staticClass:"sidebar-item",attrs:{"id":"legend"}},[_c('a',{attrs:{"href":"#","data-i18n-title":_vm.ApplicationState.sidebar.open ? '' : 'legend',"data-placement":"right"},on:{"click":function($event){$event.preventDefault();return _vm.showLegendPanel.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-list",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"treeview-label"},[_vm._v(_vm._s(_vm.$t('legend')))])])]),_vm._v(" "),_c('li',{staticClass:"sidebar-item",attrs:{"id":"metadata"}},[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#modal-metadata","data-i18n-title":_vm.ApplicationState.sidebar.open ? '' : 'Metadata',"data-placement":"right"}},[_c('i',{staticClass:"fas fa-file-code",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"treeview-label"},[_vm._v(_vm._s(_vm.$t('Metadata')))])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.ApplicationState.sidebar.open),expression:"ApplicationState.sidebar.open"}],staticClass:"sidebar-item",attrs:{"id":"themes"}},[(_vm.ApplicationState.catalog.layerstrees.length && _vm.ApplicationState.catalog.layerstrees[0].tree[0].toc)?[_c('a',{staticStyle:{"display":"flex","flex-wrap":"wrap","align-items":"center"},attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleThemeSelector.apply(null, arguments)}}},[_c('i',{staticClass:"far fa-eye",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.active_theme.theme)?_c('span',{staticClass:"current_map_theme treeview-label g3w-long-text"},[_c('span',{staticStyle:{"color":"#fff"}},[_vm._v(_vm._s(_vm.$t('THEME'))+":")]),_vm._v(" "),_c('span',{staticClass:"skin-color",staticStyle:{"font-size":"1.1em"}},[_vm._v(_vm._s(_vm.active_theme.theme))])]):_c('b',{staticClass:"treeview-label",staticStyle:{"color":"#fff"}},[_vm._v(_vm._s(_vm.$t('THEME')))]),_vm._v(" "),_c('i',{class:_vm.theme_selector_collapsed ? 'fas fa-angle-left' : 'fas fa-angle-down',staticStyle:{"margin-left":"auto","margin-right":"10px"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('ul',{class:{'menu-open': !_vm.theme_selector_collapsed},staticStyle:{"margin-bottom":"5px","border-bottom":"2px solid var(--skin-color)"},attrs:{"id":"g3w-themes"}},[((_vm.ApplicationState.project.state.map_themes.project || []).length > 0)?_c('li',{attrs:{"id":"g3w-themes-project"}},[_c('ul',{staticStyle:{"padding":"0"}},[(_vm.is_staff)?_c('li',[_c('div',{staticClass:"project_map_theme"},[_vm._v(_vm._s(_vm.$t('Project Themes')))])]):_vm._e(),_vm._v(" "),_c('li',{staticStyle:{"padding":"5px 5px 5px 17px"}},_vm._l((_vm.ApplicationState.project.state.map_themes.project),function(map_theme,i){return _c('div',{key:map_theme.theme},[_c('label',{attrs:{"for":("g3w-map_theme-" + i)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active_theme.theme),expression:"active_theme.theme"}],attrs:{"type":"radio","name":"radio","id":("g3w-map_theme-" + i)},domProps:{"value":map_theme.theme,"checked":_vm._q(_vm.active_theme.theme,map_theme.theme)},on:{"change":function($event){return _vm.$set(_vm.active_theme, "theme", map_theme.theme)}}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(map_theme.theme))])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.ApplicationState.logged)?_c('li',{attrs:{"id":"g3w-themes-user"}},[_c('ul',{staticStyle:{"padding":"0"}},[_c('li',[_c('div',{staticClass:"user_map_theme"},[_c('span',[_vm._v(_vm._s(_vm.$t('User Themes')))]),_vm._v(" "),_c('button',{staticClass:"action sidebar-button",staticStyle:{"margin-left":"auto","padding":"5px","font-size":"1.2em","border":"0"},attrs:{"type":"button","title":"add"},on:{"click":function($event){_vm.theme_dialog_open = !_vm.theme_dialog_open}}},[_c('i',{staticClass:"fas fa-plus-square",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('li',{staticStyle:{"padding":"5px 5px 5px 17px"}},_vm._l((_vm.ApplicationState.project.state.map_themes.custom),function(map_theme,i){return _c('div',{key:map_theme.theme,staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',[_c('label',{attrs:{"for":("g3w-map_theme-" + i + "-user")}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active_theme.theme),expression:"active_theme.theme"}],attrs:{"type":"radio","name":"radio","id":("g3w-map_theme-" + i + "-user")},domProps:{"value":map_theme.theme,"checked":_vm._q(_vm.active_theme.theme,map_theme.theme)},on:{"change":function($event){return _vm.$set(_vm.active_theme, "theme", map_theme.theme)}}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(map_theme.theme))])])]),_vm._v(" "),_c('span',[_c('span',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.active_theme.theme !== map_theme.theme),expression:"active_theme.theme !== map_theme.theme"}],staticClass:"action sidebar-button",staticStyle:{"padding":"5px"},attrs:{"title":"update","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.updateTheme(map_theme.theme)}}},[_c('i',{staticClass:"far fa-save",staticStyle:{"color":"var(--skin-color)"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"action sidebar-button",staticStyle:{"padding":"5px"},attrs:{"title":"cancel","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTheme(map_theme.theme)}}},[_c('i',{staticClass:"fas fa-trash",staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}})])])])}),0)])]):_vm._e()]),_vm._v(" "),_c('dialog',{ref:"add_map_theme",on:{"beforetoggle":_vm.onBeforetoggleThemeDialog}},[_c('div',{staticStyle:{"display":"flex","justify-content":"end","padding-top":"5px"}},[_c('button',{staticClass:"fas fa-times",staticStyle:{"border":"medium","line-height":"1","font-weight":"700","font-size":"15px","background":"none","width":"40px","height":"40px"},attrs:{"type":"button","title":"close"},on:{"click":function($event){$event.stopPropagation();_vm.theme_dialog_open = false}}})]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.saveTheme.apply(null, arguments)}}},[_c('label',{attrs:{"for":"add-theme"}},[_vm._v(_vm._s(_vm.$t('Name of new map theme'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.custom_theme_input),expression:"custom_theme_input"}],ref:"add_map_theme_input",staticClass:"form-control",attrs:{"id":"add-theme","type":"text","required":""},domProps:{"value":(_vm.custom_theme_input)},on:{"input":function($event){if($event.target.composing){ return; }_vm.custom_theme_input=$event.target.value}}}),_vm._v(" "),(_vm.custom_theme_invalid)?_c('p',{staticClass:"g3w-long-text error-input-message",staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('Invalid or exiting name')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-success",staticStyle:{"margin-top":"20px"},attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('add')))])])])]:_vm._e()],2),_vm._v(" "),_c('li',{staticClass:"sidebar-item",attrs:{"id":"catalog"}},[_c('a',{attrs:{"href":"#","data-i18n-title":_vm.ApplicationState.sidebar.open ? '' : 'Layers',"data-placement":"right"},on:{"click":function($event){$event.preventDefault();return _vm.showSidebar.apply(null, arguments)}}},[_c('i',{staticClass:"far fa-map",staticStyle:{"color":"rgb(1, 154, 76)"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"treeview-label"},[_vm._v(" "+_vm._s(_vm.$t('Layers')))])]),_vm._v(" "),_vm._l((_vm.ApplicationState.catalog.layerstrees),function(root){return _c('ul',{key:root.storeid,staticClass:"tree-root"},_vm._l((root.tree),function(tree){return _c('catalog-tree',{key:tree.id,attrs:{"layerstree":tree,"root":true,"legendplace":_vm.ApplicationState.project.state.legend_position || 'tab',"parent_mutually_exclusive":false,"storeid":root.storeid}})}),1)}),_vm._v(" "),(_vm.ApplicationState.catalog.external.wms.length || _vm.ApplicationState.catalog.external.tms.length || _vm.ApplicationState.catalog.external.vector.length)?_c('ul',{staticClass:"tree-root"},[_c('li',{staticClass:"tree-item group",attrs:{"tabindex":"0","role":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.expandCollapseExternaLayers.apply(null, arguments)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.expandCollapseExternaLayers.apply(null, arguments)}}},[_c('button',{staticClass:"tree-toggler",attrs:{"type":"button"}},[_c('i',{class:_vm.externalayers.collapsed ? 'fas fa-caret-right' : 'fas fa-caret-down',attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Enlarge / Reduce')))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.externalayers.checked),expression:"externalayers.checked"}],attrs:{"type":"checkbox","role":"button","aria-label":"Show/Hide"},domProps:{"checked":Array.isArray(_vm.externalayers.checked)?_vm._i(_vm.externalayers.checked,null)>-1:(_vm.externalayers.checked)},on:{"click":function($event){$event.stopPropagation();return _vm.toggleExternalLayers.apply(null, arguments)},"change":function($event){var $$a=_vm.externalayers.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.externalayers, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.externalayers, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.externalayers, "checked", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"tree-node-title"},[_vm._v(_vm._s(_vm.$t('EXTERNAL LAYERS')))]),_vm._v(" "),_c('button',{attrs:{"type":"button","title":"Remove"},on:{"click":function($event){$event.stopPropagation();return _vm.removeExternalLayers.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-trash",staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('ul',{staticClass:"group"},[_vm._l((_vm.ApplicationState.catalog.external.wms),function(wms){return _c('catalog-tree',{directives:[{name:"show",rawName:"v-show",value:(!_vm.externalayers.collapsed),expression:"!externalayers.collapsed"}],key:wms.id,attrs:{"externallayers":_vm.ApplicationState.catalog.external.wms,"layerstree":wms},on:{"layerchecked":_vm.updateExternalLayersChecked}})}),_vm._v(" "),_vm._l((_vm.ApplicationState.catalog.external.tms),function(tms){return _c('catalog-tree',{directives:[{name:"show",rawName:"v-show",value:(!_vm.externalayers.collapsed),expression:"!externalayers.collapsed"}],key:tms.id,attrs:{"externallayers":_vm.ApplicationState.catalog.external.tms,"layerstree":tms},on:{"layerchecked":_vm.updateExternalLayersChecked}})}),_vm._v(" "),_vm._l((_vm.ApplicationState.catalog.external.vector),function(vector){return _c('catalog-tree',{directives:[{name:"show",rawName:"v-show",value:(!_vm.externalayers.collapsed),expression:"!externalayers.collapsed"}],key:vector.id,attrs:{"externallayers":_vm.ApplicationState.catalog.external.vector,"layerstree":vector},on:{"layerchecked":_vm.updateExternalLayersChecked}})})],2)])]):_vm._e()],2),_vm._v(" "),(_vm.has_related_maps && _vm.ApplicationState.sidebar.open)?_c('li',{staticClass:"sidebar-footer",staticStyle:{"position":"sticky","bottom":"0","background-color":"var(--bgcolor)","display":"flex","text-align":"center","color":"#fff","border-top":"2px solid var(--skin-color)","justify-content":"space-around"}},[_c('a',{staticStyle:{"border":"none"},attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.showaddLayerModal.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-layer-group",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('Add Layer')))])]),_vm._v(" "),(_vm.has_related_maps && !_vm.ApplicationState.iframe)?_c('a',{staticStyle:{"border":"none"},attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.openChangeMapMenu.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-sync-alt",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('changemap')))])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"sidebar-aside-toggle",attrs:{"href":"#","role":"button","title":"Sidebar menu","data-placement":"right"},on:{"click":function($event){$event.preventDefault();return _vm.toggleSidebar.apply(null, arguments)}}})]),_vm._v(" "),_c('div',{staticClass:"content-wrapper",style:({ paddingTop: _vm.ApplicationState.iframe ? 0 : null })},[_c('bar-loader',{staticStyle:{"position":"absolute","z-index":"1"},attrs:{"loading":_vm.state.content.loading && 0 === _vm.state.contentsdata.length}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","duration":{ enter: 500, leave: 500 }}},[(_vm.usermessage.show)?_c('user-message',{attrs:{"title":_vm.usermessage.title,"subtitle":_vm.usermessage.subtitle,"id":_vm.usermessage.id,"message":_vm.usermessage.message,"closable":_vm.usermessage.closable,"textMessage":_vm.usermessage.textMessage,"icon-class":_vm.usermessage.iconClass},on:{"close-usermessage":_vm.closeUserMessage}},[(_vm.usermessage.hooks.header)?_c('template',{slot:"header"},[_c(_vm.usermessage.hooks.header,{tag:"component"})],1):_vm._e(),_vm._v(" "),(_vm.usermessage.hooks.body)?_c('template',{slot:"body"},[_c(_vm.usermessage.hooks.body,{tag:"component"})],1):_vm._e(),_vm._v(" "),(_vm.usermessage.hooks.footer)?_c('template',{slot:"footer"},[_c(_vm.usermessage.hooks.footer,{tag:"component"})],1):_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"g3w-view map",class:("split-" + (_vm.state.split)),style:(_vm.styles.map),attrs:{"id":"g3w-view-map"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.has_panel),expression:"has_panel"}],class:("split-" + (_vm.state.split)),attrs:{"id":"resize-map-and-content"},on:{"mousedown":function($event){$event.stopPropagation();return _vm.onResize.apply(null, arguments)}}}),_vm._v(" "),_c('div',{attrs:{"id":"application-notifications"}},[_c('div',{class:{ 'g3w-hide': _vm.ApplicationState.online },staticStyle:{"color":"#999"}},[_c('i',{staticClass:"fas fa-wifi",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{staticStyle:{"font-size":"0.4em"}},[_vm._v("offline")])]),_vm._v(" "),_c('div',{class:{ 'skin-color': true, 'g3w-hide': !_vm.ApplicationState.download }},[_c('bar-loader',{attrs:{"loading":true}}),_vm._v(" "),_c('i',{staticClass:"fas fa-download",staticStyle:{"padding":"3px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{staticStyle:{"font-size":"0.35em"}},[_vm._v("download")])],1),_vm._v(" "),_c('div',{class:{ 'g3w-hide': 0 === _vm.ApplicationState.plugins.length },staticStyle:{"color":"#994b10"}},[_c('bar-loader',{attrs:{"loading":true}}),_vm._v(" "),_c('i',{staticClass:"fas fa-cogs",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{staticStyle:{"font-size":"0.4em"}},[_vm._v("plugins")])],1)]),_vm._v(" "),_c('div',{attrs:{"id":"g3w-maps"}},[_vm._l((_vm.ApplicationState.hidemaps),function(hidemap){return _c('div',{key:hidemap.id,staticClass:"g3w-map hidemap",attrs:{"id":hidemap.id}})}),_vm._v(" "),_c('div',{staticClass:"g3w-map",attrs:{"id":_vm.GUI.target},on:{"drop":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)},"dragenter":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)},"dragleave":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)},"dragover":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"drop-area",attrs:{"hidden":""}},[_vm._v("\n            Upload Files\n          ")]),_vm._v(" "),_c('div',{ref:"g3w-map-controls",staticClass:"g3w-map-controls rv",staticStyle:{"display":"flex"}}),_vm._v(" "),(_vm.ApplicationState.map_info)?_c('div',{ref:"g3w-map-info",style:(_vm.ApplicationState.map_style),attrs:{"id":"g3w-map-info"}},[_vm._v("\n            "+_vm._s(_vm.ApplicationState.map_info)+"\n          ")]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"g3w-map-controls-left-bottom"})]),_vm._v(" "),_c('div',{attrs:{"id":"map_footer"}},[_c('a',{staticStyle:{"margin-left":"5px","align-self":"center"},attrs:{"href":"https://g3wsuite.it/","target":"_blank","title":_vm.version}},[_c('img',{attrs:{"height":"15","src":"/static/client/images/g3wsuite_logo.png","alt":""}}),_vm._v(" "),_c('span',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.version))])]),_vm._v(" "),_c('div',{attrs:{"id":"attribution-control"}}),_vm._v(" "),_c('div',{staticStyle:{"margin-right":"auto"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mouse.visible),expression:"mouse.visible"}],attrs:{"id":"mouse-position-control"}}),_vm._v(" "),(_vm.mouse.visible && _vm.mouse.switch_icon && !_vm.isMobile())?_c('button',{staticClass:"btn",staticStyle:{"border-radius":"0"},attrs:{"type":"button","title":_vm.mouse.tooltip,"data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.switchMapsCoordinateTo4326.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-mouse",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t(_vm.mouse.tooltip)))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",staticStyle:{"border-radius":"0"},attrs:{"type":"button","title":"Copy share URL","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.showEmbedModal.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-share-alt",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Copy share URL')))])]),_vm._v(" "),_c('div',{attrs:{"id":"scale-control"}}),_vm._v(" "),(_vm.showmapunits)?_c('div',{attrs:{"id":"scale-line-units"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ApplicationState.map_unit),expression:"ApplicationState.map_unit"}],staticStyle:{"padding":"5px 2px","font-weight":"bold","border":"0","cursor":"pointer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.ApplicationState, "map_unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.state.mapunits),function(unit){return _c('option',{directives:[{name:"t",rawName:"v-t",value:(("scaleline_units." + unit)),expression:"`scaleline_units.${unit}`"}],staticStyle:{"font-weight":"bold"},domProps:{"value":unit,"selected":_vm.ApplicationState.map_unit === unit}})}),0)]):_vm._e()])],2)]),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.content.disabled),expression:"state.content.disabled"}],staticClass:"g3w-view content",class:("split-" + (_vm.state.split)),style:(_vm.styles.content),attrs:{"id":"g3w-view-content"}},[(_vm.breadcrumb.length > 1)?_c('nav',{staticClass:"content_breadcrumb",attrs:{"aria-label":"breadcrumb"}},[_c('ul',_vm._l((_vm.breadcrumb),function(crumb,index){return _c('li',{key:crumb},[_c('button',{attrs:{"type":"button","aria-current":index === _vm.breadcrumb.length - 1 ? 'page' : undefined},on:{"click":function($event){$event.stopPropagation();return _vm.popContent(_vm.breadcrumb.length - index -1)}}},[_vm._v(_vm._s(_vm.$t(crumb || '')))])])}),0)]):_vm._e(),_vm._v(" "),((_vm.showtitle && _vm.contentTitle) || _vm.previousTitle || _vm.state.content.closable)?_c('div',{staticClass:"close-panel-block",staticStyle:{"display":"flex","justify-content":"space-between"}},[(_vm.previousTitle)?_c('button',{staticClass:"action-button action-button-back",staticStyle:{"font-size":"0.8em"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.popContent(1)}}},[_c('i',{staticClass:"fas fa-chevron-circle-left",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('back')))])]):_vm._e(),_vm._v(" "),(!_vm.previousTitle && _vm.showtitle && _vm.contentTitle)?_c('div',{staticClass:"panel-title"},[_c('b',[_vm._v(_vm._s([(_vm.contentTitle.text ? _vm.contentTitle.title || '' : _vm.$t(_vm.contentTitle.title || '')), _vm.$t(_vm.contentTitle.post_title || '')].filter(Boolean).join(' ')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"g3-content-header-action-tools",staticStyle:{"display":"flex","align-items":"center","gap":".5ch","padding":"0 .5ch"}},[_vm._l((_vm.state.content.headertools),function(tool){return _c(tool,{tag:"component"})}),_vm._v(" "),(undefined !== _vm.state.split)?_c('button',{staticClass:"action-button action-button-resize skin-color-dark",class:_vm.$fa(("resize-" + (_vm.state.split))),staticStyle:{"margin-right":"3px"},attrs:{"type":"button","title":"Enlarge / Reduce","data-placement":"bottom"},on:{"click":_vm.resizeFull}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"action-button action-button-dock skin-color-dark fa fa-external-link-alt",staticStyle:{"scale":".9"},style:({ transform: 'h' === _vm.state.split ? 'rotate(134deg)' : 'rotate(44deg)'}),attrs:{"type":"button","data-i18n-title":'h' === _vm.state.split ? 'Dock to Bottom' : 'Dock to Right',"data-placement":"bottom"},on:{"click":_vm.splitContent}}),_vm._v(" "),(_vm.state.content.closable)?_c('button',{staticClass:"action-button action-button-close skin-color-dark fas fa-times",class:{'mobile': _vm.isMobile()},attrs:{"type":"button","title":"close","data-placement":"bottom"},on:{"click":_vm.closeContent}}):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.state.content.loading}})],1)],1),_vm._v(" "),_c('context-menu'),_vm._v(" "),(!_vm.state.cookie_accepted)?_c('div',{staticClass:"cookie-banner"},[_c('div',[_vm._v(_vm._s(_vm.$t('This website uses cookies to ensure you get the best experience on our website.')))]),_vm._v(" "),_c('button',{staticClass:"cookie-button",on:{"click":_vm.acceptCookie}},[_vm._v(_vm._s(_vm.$t('Got It!')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal fade modal-fullscreen",attrs:{"id":"modal-fullscreen","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false","aria-labelledby":"modal-fullscreen","aria-hidden":"true"}}),_vm._v(" "),(!_vm.user && _vm.has_iframe_login)?_c('modal-login'):_vm._e(),_vm._v(" "),_c('modal-addlayer'),_vm._v(" "),_c('modal-changemap'),_vm._v(" "),_c('modal-metadata')],1)}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('div',{attrs:{"id":"marker"}})])}]

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "App.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__